"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDay = exports.todayStripped = exports.interpolateHours = exports.addDays = exports.removeFromArray = exports.toggleArrayObject = exports.toggleArray = exports.isInObject = exports.isInArray = exports.signOff = void 0;
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
// @ts-ignore
const signOff = async (props) => {
    await async_storage_1.default.multiRemove([
        'JWT',
        'User',
        'Register1',
        'Register2',
        'Register3',
    ]);
    props.nav();
};
exports.signOff = signOff;
const isInArray = (array, value) => {
    const result = array.indexOf(value);
    return result > -1;
};
exports.isInArray = isInArray;
const isInObject = (dict, key) => {
    return key in dict;
};
exports.isInObject = isInObject;
const toggleArray = (array, value, setFunction) => {
    const index = array.indexOf(value);
    if (index > -1) {
        array.splice(index, 1);
    }
    else {
        array.push(value);
    }
    setFunction([...array]);
};
exports.toggleArray = toggleArray;
const toggleArrayObject = (array, value) => {
    const index = array.indexOf(value);
    if (index > -1) {
        array.splice(index, 1);
    }
    else {
        array.push(value);
    }
    return array;
};
exports.toggleArrayObject = toggleArrayObject;
const removeFromArray = (array, value) => {
    const index = array.indexOf(value);
    if (index > -1) {
        array.splice(index, 1);
    }
    return array;
};
exports.removeFromArray = removeFromArray;
const addDays = (date, days) => {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy;
};
exports.addDays = addDays;
const interpolateHours = (date) => {
    let finalDateParsed = date.toISOString().split('T');
    finalDateParsed[1] = '00:00:00Z';
    let toString = finalDateParsed.join('T');
    return new Date(toString);
};
exports.interpolateHours = interpolateHours;
const todayStripped = () => {
    let today = new Date().toISOString();
    return today.substring(0, today.length - 5);
};
exports.todayStripped = todayStripped;
const toDay = (dayNumber) => {
    switch (dayNumber) {
        case 0:
            return 'Sonntag';
        case 1:
            return 'Montag';
        case 2:
            return 'Dienstag';
        case 3:
            return 'Mittwoch';
        case 4:
            return 'Donnerstag';
        case 5:
            return 'Freitag';
        case 6:
            return 'Samstag';
        default:
            return 'Monday';
    }
};
exports.toDay = toDay;
